<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },

    success: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <button
        :type="type"
        :class="[
            'focus-visible:outline-brand-obg-brand-orange block w-full cursor-pointer rounded-xl px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2',
            success ? 'bg-green-500' : 'bg-brand-orange hover:bg-brand-orange/80',
        ]"
    >
        <Transition
            leave-active-class="transition ease-in duration-1000"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <template v-if="success"> Úspěšně odesláno </template>
            <template v-else>
                <slot />
            </template>
        </Transition>
    </button>
</template>
